var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" Grading Guidelines ")]},proxy:true},{key:"main",fn:function(){return [_c('GradingGuidelinesBody')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }